module.exports = __webpack_public_path__ + "static/img/fitness-band.e9dc100.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/fitness-band.png
// module id = N4/k
// module chunks = 1